import React, { Component } from "react"
import PropTypes from 'prop-types'

import { Alert,Media, Card,Input,Button, CardBody, Col, Container, Row } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import ModalMessage from "../pages/messages/ModalMessage"
//Social Media Imports
import { GoogleLogin } from "react-google-login"
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"

//Import config
import { facebook, google } from "../../config"

// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"

// actions
import { apiError, loginUser, socialLogin } from "../../store/actions"
import  { Redirect } from 'react-router-dom'
// import images
import user1 from "../../assets/images/users/avatar-unisex.jpg"
import logosis from "../../assets/images/logoSISblue2.png"
import logo from "../../assets/images/logoSIS.png"
import lightlogo from "../../assets/images/logo-light.svg"
import $ from "jquery";
import url from "../../common/api"
import './profil.css'
import {patchQueries} from "../../queries/patchQueries.js"
class profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ok:"",
      dataSend:false,
      user:JSON.parse(sessionStorage.getItem("authAshia")),
      show:false,
      success:true,
      message:"Mot de passe modifié avec succès !",
      titre:"Message modification de mot de passe",
      boutton:"OK",
      update_fonction:false,
      update_tel:false,
    }
    this.handleUpdateIdentite.bind(this)

  }



  handleValidate=()=>{
    if(this.state.success){
      //sessionStorage.removeItem("authAshia")
      this.setState({ok: <Redirect to='/login'  />});
    }else{
      this.setState({show:false});
    }
      
  }


  handleAnnuler=()=>{
    this.setState({ok: <Redirect to='/accueil'  />});
  }

  handleUpdateIdentite=(id)=>{
    console.log("inter")
    let user=this.state.user
    
    if(id==1 && $("#tel").val()!==""){
       
       user.telephone=$("#tel").val()
       this.setState({user})
       this.setState({update_fonction:false,update_tel:false})

       patchQueries("utilisateurs/"+this.state.user?.id,{telephone:$("#tel").val()}).then(data=>{
         console.log("ok",data)
         sessionStorage.setItem("authAshia", JSON.stringify(data))
      })
    }else{

      if(id==2 && $("#fonction").val()!==""){
        user.fonction=$("#fonction").val()
        this.setState({user})
        this.setState({update_fonction:false,update_tel:false})
        patchQueries("utilisateurs/"+this.state.user?.id,{fonction:$("#fonction").val()}).then(data=>{
        sessionStorage.setItem("authAshia", JSON.stringify(data))
         
       })
     }else{
      console.log("none")
      this.setState({update_fonction:false,update_tel:false})
     }

    }

  


   

  }

  handleUpdatePassword=()=>{
    this.setState({dataSend:true})
    if($("#password1").val()!==this.state.user?.password){
      this.setState({dataSend:false})
      this.setState({message:"Ancien mot de passe incorrect !"})
      this.setState({show:true,success:false});
      $("#password1").val("")
    }else{
      if(($("#password1").val()=="" || $("#password2").val()=="")){
        this.setState({dataSend:false})
        this.setState({message:"Vous devez saisir votre nouveau mot de passe"})
        this.setState({show:true,success:false});
        $("#password2").val("")
        $("#password3").val("")
      }else{
        if(($("#password2").val()!==$("#password3" ).val())){
          this.setState({dataSend:false})
          this.setState({message:"Veuillez saisir des mot de passe identiques !"})
          this.setState({show:true,success:false});
          $("#password2").val("")
          $("#password3").val("")
        }else{
          patchQueries("utilisateurs/"+this.state.user?.id,{password:$("#password3").val()}).then(data=>{
            this.setState({dataSend:false})
            this.setState({message:"Mot de passe modifié avec succès !"})
            this.setState({show:true,success:true});
          // sessionStorage.removeItem("authAshia")
            // setTimeout(()=>{
              
            //   window.location.reload(false)
            //   }
            // , 3000)
            this.setState({ok: <Redirect to='/login'  />});
          })
        }
      }  
    }
  }

  componentDidMount() {
    sessionStorage.setItem("sis-session",900000)

    }


  render() {
    return (
      <React.Fragment> {this.state.ok}
        
        <ModalMessage
              show={this.state.show}
              success={this.state.success}
              boutton={this.state.boutton}
              handleValidate={this.handleValidate}
              message={this.state.message}
              titre={this.state.titre}
              onCloseClick={() => this.setState({ show: false })}
              />
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Card>
              <CardBody>
                <Row className="justify-content-center">
                  <h3 style={{textAlign:"center"}}>Mon compte</h3>
                  <hr/>
                  <Col md="6" sm="12">
                    <figure class="snip1336">
                      <img src={logosis} alt="sample87" />
                      <figcaption>
                        <img src={user1} alt="profile-sample4" class="profile" />
                        <h1>{this.state.user?.nom} {this.state.user?.prenom} </h1>
                        {/* <h2>Hans Down<span>Engineer</span></h2> */}
                        {/* <p>I'm looking for something that can deliver a 50-pound payload of snow on a small feminine target. Can you suggest something? Hello...? </p> */}
                        
                        <div className="mb-0">  Email :          <span>{this.state.user?.email}</span></div>
                        {!this.state.update_tel?
                          <div className="mb-0">  Téléphone :          <span>{this.state.user?.telephone}</span> <span onClick={e=>this.setState({update_tel:true})} style={{color:"#5FC4E1",cursor:"pointer"}} className="bx bxs-pencil bx-sm"></span></div>:
                          <div  className="mb-3">
                            <Input
                              className="form-control"
                              type="text" 
                              id="tel"
                              defaultValue={this.state.user?.telephone}
                            />
                            <span onClick={e=>this.setState({update_tel:false})} style={{float:"left",borderRadius:5,backgroundColor:"#f46a6a"}}   color="secondary" className="b-md mt-2 mb-2" type="button"> Annuler </span> <span onClick={this.handleUpdateIdentite.bind(this.bind,1)} style={{float:"right",borderRadius:5,backgroundColor:"#34c38f"}}   color="success" className="b-md mt-2 mb-2" type="button"> Modifier </span> 
                             <br/>
                              
                          </div>
                        }
                        {!this.state.update_fonction?
                          <div className="mb-0" style={{float:"left"}}>  Fonction :          <span>{this.state.user?.fonction}</span> <span onClick={e=>this.setState({update_fonction:true})} style={{color:"#5FC4E1",cursor:"pointer"}} className="bx bxs-pencil bx-sm"></span></div>:
                          <div  className="mt-2">
                          <Input
                            className="form-control"
                            type="text" 
                            id="fonction"
                            defaultValue={this.state.user?.fonction}
                          />
                          <span onClick={e=>this.setState({update_fonction:false})} style={{float:"left",borderRadius:5,backgroundColor:"#f46a6a"}}   color="secondary" className="b-md mt-2 mb-2" type="button"> Annuler </span> <span onClick={this.handleUpdateIdentite.bind(this.bind,2)} style={{float:"right",borderRadius:5,backgroundColor:"#34c38f"}}   color="success" className="b-md mt-2 mb-2" type="button"> Modifier </span> 
                           <br/>
                            
                        </div>
                        }
                       
                        {/* <a href="#" class="follow">Follow</a>
                        <a href="#" class="info">More Info</a> */}
                      </figcaption>
                    </figure>
                  </Col>
                  <Col md="6" sm="12">
                    <h3 style={{textAlign:"center"}}>Modifier votre mot de passe</h3>
                    <hr/>
                    <label>Ancien mot de passe</label>
                    <Input
                      className="form-control"
                      type="text" 
                      id="password1"
                    />

                    <label>Nouveau mot de passe</label>
                    <Input
                      className="form-control"
                      type="password" 
                      id="password2"
                    />

                    <label>Repéter mot de passe</label>
                    <Input
                      className="form-control"
                      type="password" 
                      id="password3"
                    />
                      <Row className="justify-content-center mt-5">
                        <Col md="6">
                          { !this.state.dataSend?
                            <Button style={{float:"right"}} id="initial" onClick={this.handleUpdatePassword} color="success" block className="b-lg" >
                            Modifier
                          </Button>:
                          <Button style={{float:"right"}}   color="success" className="b-lg" type="button" disabled>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                            Chargement...
                          </Button> 
                          }
                        </Col>
                        <Col md="6">
                          <Button  onClick={this.handleAnnuler} color="secondary" block className="b-lg">
                            Annuler
                          </Button>
                        </Col>
                      </Row>
                  </Col>
                </Row>

                


{/* 

                <Row className="justify-content-center">
                  <h3 style={{textAlign:"center"}}>Mon profil</h3>
                  <hr/>
                  <Col md="6" sm="12">
                  <Media>
                      <div className="me-3">
                        <img
                          src={user1}
                          alt=""
                          className="avatar-md rounded-circle img-thumbnail"
                        />
                      </div>
                      <Media body className="align-self-center">
                        <div className="text-muted">
                          <h5>{this.state.user?.nom}</h5>
                          //<p className="mb-1">{this.state.user?.email}</p> 
                          
                        </div>
                      </Media>
                    </Media>
                  </Col>
                  <Col md="6" sm="12">
                    <br/>
                    <div className="mb-2"><strong> Nom :         </strong><span>{this.state.user?.nom}</span></div>
                    <div className="mb-2"><strong> Prénom :         </strong><span>{this.state.user?.prenom}</span></div>
                    <div className="mb-2"><strong> Email :         </strong><span>{this.state.user?.email}</span></div>
                    <div className="mb-2"><strong> Téléphone :         </strong><span>{this.state.user?.telephone}</span></div>
                    <div className="mb-2"><strong> Fonction :         </strong><span>{this.state.user?.fonction}</span></div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <hr/>
            <Card>
              <CardBody>
                <Row className="justify-content-center mt-2">
                <h3 style={{textAlign:"center"}}>Modifier votre mot de passe</h3>
                <hr/>
                <Col md="12" className="mt-3">
                        <label>Ancien mot de passe</label>
                        
                        <Input
                          className="form-control"
                          type="text" 
                          id="password1"
                        />
                  </Col>
                </Row>
                
                <Row className="justify-content-center mt-5">
                <Col md="12" className="mt-3">
                        <label>Nouveau mot de passe</label>
                        
                        <Input
                          className="form-control"
                          type="password" 
                          id="password2"
                        />
                  </Col>
                  <Col md="12" className="mt-3">
                        <label>Repéter mot de passe</label>
                        
                        <Input
                          className="form-control"
                          type="password" 
                          id="password3"
                        />
                  </Col>
                </Row>
                <Row className="justify-content-center mt-5">
                      <Col md="6">
                        { !this.state.dataSend?
                          <Button style={{float:"right"}} id="initial" onClick={this.handleUpdatePassword} color="success" block className="b-lg" >
                          Modifier
                        </Button>:
                         <Button style={{float:"right"}}   color="success" className="b-lg" type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                          Chargement...
                        </Button> 
                        }
                      </Col>
                      <Col md="6">
                        <Button  onClick={this.handleAnnuler} color="secondary" block className="b-lg">
                          Annuler
                        </Button>
                      </Col>
                      
                    </Row> */}


              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}



export default profile